/**
 * Transform
 * ======================================
 */

 const WIDGETS = '.js-Transform'
 const ACTIVECLASS = 'is-switch'
 const IS_COARSE = matchMedia('(pointer:coarse)').matches

 export class Transform {
   constructor() {
     this.elements = document.querySelectorAll(WIDGETS)
   }

   init = () => {
    this.elements.forEach((el) => {
      const btns = el.querySelectorAll('.transform__nav-item')

      btns.forEach((item) => {
        item.addEventListener('click', this.clickHandler, false)
      })
   })
   }

   clickHandler = (e) => {
    const el = e.currentTarget
    const parent = el.closest(WIDGETS)
    const btnChildren = el.closest('.transform__nav').querySelector('.transform__nav-item.is-active')

    if(!el.classList.contains('is-active')){
      btnChildren.classList.remove('is-active')
      el.classList.add('is-active')

      parent.classList.toggle(ACTIVECLASS)
    }

    e.preventDefault()
   }
 }

  const DropdownObject = new Transform()
  DropdownObject.init()
